export default __webpack_public_path__ + "static/media/ReportIcon-WomensHealth-MS.feab2384.jpg";